import moment from 'moment';
import momentTZ from 'moment-timezone';
import { Logger } from 'common/logger';
import { DATE_LONG_FORMAT, APP_TIMEZONE } from 'common/constants';
import { turbine1dQuery, turbine30davgQuery, turbineCurrentStateQuery, catchErrorsV2 } from '../ReportsAPI';
import { getSelectedItems } from 'common/state.helper';
import { inAppTimezone } from 'common/dates';

/* eslint-disable camelcase */

export const turbineSummary = {
    name: 'turbineSummary',
    state: {
        selectedTurbine: '',
        turbine: {
            total_number_of_persons_visited: 0,
            average_generation: 0,
            was_unavailable_some: false,
            notes_count: 0,
            restrictions_count: 0,
            exceptions_count: 0,
            release_of_plant_duration: 0,
            total_generation_vs_average_generation: 0,
            was_stopped_some: false,
            total_number_of_visits: 0,
            commercial_availability: 0,
            release_of_plant_count_hv: 0,
            wind_speed: 0,
            capacity_factor: 0,
            release_of_plant_count_wt: 0,
            total_generation: 0,
        },
        average: {
            total_number_of_persons_visited: 0,
            average_generation: 0,
            was_unavailable_some: false,
            notes_count: 0,
            restrictions_count: 0,
            exceptions_count: 0,
            release_of_plant_duration: 0,
            total_generation_vs_average_generation: 0,
            was_stopped_some: false,
            total_number_of_visits: 0,
            commercial_availability: 0,
            release_of_plant_count_hv: 0,
            wind_speed: 0,
            capacity_factor: 0,
            release_of_plant_count_wt: 0,
            total_generation: 0,
        },
    },

    reducers: {
        setAverageData(state, { payload }) {
            return { ...state, average: { ...state.average, ...payload } };
        },
        setTurbineData(state, { payload }) {
            return { ...state, turbine: { ...state.turbine, ...payload } };
        },
        selectTurbine(state, { selectedTurbine }) {
            return { ...state, selectedTurbine };
        },
    },

    effects: (dispatch) => ({
        async loadAll() {
            await catchErrorsV2(
                () => dispatch.turbineSummary.queryAverageData(),
                () => dispatch.turbineSummary.setAverageData({ payload: {} })
            );
            await catchErrorsV2(
                () => dispatch.turbineSummary.queryTurbineData(),
                () => dispatch.turbineSummary.setTurbineData({ payload: {} })
            );
            await catchErrorsV2(
                () => dispatch.turbineSummary.queryTurbineCurrentState(),
                () => dispatch.turbineSummary.setTurbineData({ payload: {} })
            );
        },
        async queryTurbineCurrentState(_, rootState) {
            const { selectedParkId, selectedTurbineKey } = getSelectedItems(rootState);

            const today = inAppTimezone();
            const { data } = await turbineCurrentStateQuery(today, selectedParkId, selectedTurbineKey);

            if (data && data.length > 0) {
                const { state, last_rop_released, last_rop_duration } = data[0];

                const lastReleaseDate = moment(last_rop_released).isValid()
                    ? momentTZ
                          .utc(last_rop_released)
                          .tz(APP_TIMEZONE)
                          .format(DATE_LONG_FORMAT)
                    : null;
                const lastReleaseDuration = last_rop_duration
                    ? moment.duration(last_rop_duration, 'h').format('h[h] m[min]')
                    : null;

                dispatch.turbineSummary.setTurbineData({
                    payload: {
                        currentStatus: state,
                        lastReleaseDate,
                        lastReleaseDuration,
                    },
                });
            }
        },
        async queryAverageData(_, rootState) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = getSelectedItems(rootState);

            const { data } = await turbine30davgQuery(selectedDate, selectedParkId, selectedTurbineKey);

            if (data && data.length > 0) {
                const item = data[0];
                const { release_of_plant_duration } = item;

                dispatch.turbineSummary.setAverageData({
                    payload: {
                        ...item,
                        releaseOfPlantDuration: moment.duration(release_of_plant_duration, 'h').asMilliseconds(),
                    },
                });
                Logger.info('Average data loaded');
            } else {
                Logger.info('Average data loaded, but empty');
                dispatch.turbineSummary.setAverageData({ payload: {} });
            }
        },
        async queryTurbineData(_, rootState) {
            const { selectedDate, selectedParkId, selectedTurbineKey } = getSelectedItems(rootState);

            const { data } = await turbine1dQuery(selectedDate, selectedParkId, selectedTurbineKey);

            if (data && data.length > 0) {
                const item = data[0];
                const { release_of_plant_duration } = item;

                dispatch.turbineSummary.setTurbineData({
                    payload: {
                        ...item,
                        releaseOfPlantDuration: moment.duration(release_of_plant_duration, 'h').asMilliseconds(),
                    },
                });
                Logger.info('Park data loaded');
            } else {
                Logger.info('Park data loaded, but empty');
                dispatch.turbineSummary.setTurbineData({ payload: {} });
            }
        },
        async fakeEffectForUnitTest() {
            return new Promise((resolve) => {
                resolve('');
            });
        },
    }),
};

export default turbineSummary;
